import { sentenceCase } from 'change-case'

import { fromCents } from '@ankor-io/common/domain/pay/currency'
import type { CardLimit } from '@ankor-io/common/types/cards'
import { formatCurrency } from '@ankor-io/common/util/currencies'

import { Heading } from '@/ui-components/Heading'
import { ProgressBar } from '@/ui-components/ProgressBar'

export const CardControls = ({ currency, limits }: { currency: string; limits: CardLimit[] }) => {
  return (
    <div className="border shadow-sm rounded-lg dark:shadow-gray-800 border-gray-200 dark:border-gray-700">
      <div className="p-4">
        <div className="flex gap-2 items-center justify-between">
          <Heading level={3}>Card Controls</Heading>
        </div>
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Limits reset at 10:00 AM UTC+10 the following day
        </p>
      </div>
      <hr className="border-gray-200 dark:border-gray-700" />
      <div className="p-4">
        {/* Usage row */}
        <div className="grid md:grid-cols-3 items-center justify-between">
          {limits.map((limit) => (
            <div
              key={limit.id}
              className="flex items-center gap-x-4 md:gap-x-8 col-span-2"
            >
              <span className="w-36 text-nowrap text-sm font-medium text-gray-500 dark:text-gray-400">
                {sentenceCase(limit.interval)}
              </span>
              <ProgressBar
                value={limit.amountCents > 0 ? 0 / limit.amountCents : 0}
                label={
                  <>
                    <span className="text-sm font-semibold text-gray-900 dark:text-white">
                      {formatCurrency(0, currency)}
                    </span>
                    <span className="text-gray-400 dark:text-gray-500">
                      {' '}
                      / {formatCurrency(fromCents(limit.amountCents), currency)}
                    </span>
                  </>
                }
              />
            </div>
          ))}
        </div>

        {/* TODO: if required, bring back transaction details later with transaction endpoint */}
        {/* <hr className="my-4 border-gray-200 dark:border-gray-700" /> */}

        {/* Two-column grid */}
        {/* <div className="flex flex-col md:grid md:grid-cols-2 xl:flex xl:flex-col 2xl:grid 2xl:grid-cols-2 gap-4 text-sm"> */}
        {/* Left column */}
        {/* <div className="flex flex-col gap-4">
            <div className="flex md:grid md:grid-cols-2 xl:flex 2xl:grid 2xl:grid-cols-2 gap-4">
              <span className="text-gray-500 dark:text-gray-400">Transaction limit</span>
              <span className="flex gap-x-2 items-center font-semibold text-gray-900 dark:text-white">
                {TRANSACTION_LIMIT.amount.toLocaleString('en-US', {
                  style: 'decimal',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{' '}
                {TRANSACTION_LIMIT.currency}
                <Info
                  className="size-4 cursor-pointer"
                  data-tooltip-id="limit-info"
                />
                <Tooltip id="limit-info">Maximum allowed per month</Tooltip>
              </span>
            </div>

            <div className="flex md:grid md:grid-cols-2 xl:flex 2xl:grid 2xl:grid-cols-2 gap-4">
              <span className="text-gray-500 dark:text-gray-400">Transaction types</span>
              <div className="flex gap-x-2 items-center font-semibold text-gray-900 dark:text-white">
                {TRANSACTION_TYPES > 0 ? `${TRANSACTION_TYPES} enabled` : 'None'}
                <Info
                  className="size-4 cursor-pointer"
                  data-tooltip-id="types-info"
                />
                <Tooltip id="types-info">Number of enabled transaction types</Tooltip>
              </div>
            </div>
          </div> */}

        {/* Right column */}
        {/* <div className="flex flex-col gap-4">
            <div className="flex md:grid md:grid-cols-2 xl:flex 2xl:grid 2xl:grid-cols-2 gap-4">
              <span className="text-gray-500 dark:text-gray-400">Date limit</span>
              <span className="font-semibold text-gray-900 dark:text-white">{DATE_LIMIT}</span>
            </div>

            <div className="flex md:grid md:grid-cols-2 xl:flex 2xl:grid 2xl:grid-cols-2 gap-4">
              <span className="text-gray-500 dark:text-gray-400">Card expenses</span>
              <span className="font-semibold text-gray-900 dark:text-white">
                {CARD_EXPENSES_ENABLED ? 'Enabled' : 'Disabled'}
              </span>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default CardControls
